import React from "react";
import useReveal from "../../hooks/useReveal";

// Wraps children so they fade + rise into place the first time they enter view.
// `delay` staggers siblings. All motion collapses under prefers-reduced-motion
// via CSS, so this stays purely presentational.
export default function Reveal({
  as: Tag = "div",
  className = "",
  delay = 0,
  style,
  children,
  ...rest
}) {
  const [ref, inView] = useReveal();
  const merged = delay ? { "--reveal-delay": `${delay}ms`, ...style } : style;

  return (
    <Tag
      ref={ref}
      data-reveal={inView ? "in" : "out"}
      className={className}
      style={merged}
      {...rest}
    >
      {children}
    </Tag>
  );
}
